import { irregular } from '@ember-data/request-utils/string';

irregular('bulk_mlos', 'bulk_mlos');
